var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWebsite = function SvgWebsite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.333,
    clipPath: "url(#website_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 4.667A6 6 0 0 0 8 2a6 6 0 0 0-4.99 2.667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.667 2c-.52.832-.93 1.729-1.218 2.667M8.333 2c.52.832.93 1.729 1.219 2.667M13 11.333A6 6 0 0 1 8 14a6 6 0 0 1-4.99-2.667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.667 14a11.3 11.3 0 0 1-1.218-2.667M8.333 14c.52-.832.93-1.729 1.219-2.667M1.333 6.667 2 9.333l1-2.666 1 2.666.667-2.666M11.333 6.667 12 9.333l1-2.666 1 2.666.667-2.666M6.333 6.667 7 9.333l1-2.666 1 2.666.667-2.666"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "website_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgWebsite;